var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 17",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.499 8a.5.5 0 10-1 0v3a.5.5 0 001 0V8zm.25-2a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM8 1.5a7 7 0 100 14 7 7 0 000-14zm-6 7a6 6 0 1112 0 6 6 0 01-12 0z",
    fill: "#000"
  })));
}
export default SvgInfoThin;